import { diff3Merge } from 'node-diff3';

/**
 * Three-way merge of markdown documents, line based.
 *
 *   base   – what this user loaded (normalized)
 *   mine   – what this user is trying to save
 *   theirs – what someone else saved in the meantime
 *
 * Non-overlapping edits merge automatically. Overlapping ones become
 * conflict hunks the user resolves in the MergeDialog.
 */

export type MergeHunk =
  | { kind: 'ok'; lines: string[] }
  | { kind: 'conflict'; mine: string[]; theirs: string[]; base: string[]; choice: 'mine' | 'theirs' | 'both' };

export interface MergeOutcome {
  hunks: MergeHunk[];
  conflicts: number;
}

export function threeWayMerge(base: string, mine: string, theirs: string): MergeOutcome {
  const regions = diff3Merge(mine.split('\n'), base.split('\n'), theirs.split('\n'), { excludeFalseConflicts: true });
  const hunks: MergeHunk[] = [];
  let conflicts = 0;
  for (const r of regions) {
    if (r.ok) {
      hunks.push({ kind: 'ok', lines: r.ok });
    } else if (r.conflict) {
      conflicts += 1;
      hunks.push({ kind: 'conflict', mine: r.conflict.a, base: r.conflict.o, theirs: r.conflict.b, choice: 'mine' });
    }
  }
  return { hunks, conflicts };
}

export function applyMerge(hunks: MergeHunk[]): string {
  const out: string[] = [];
  for (const h of hunks) {
    if (h.kind === 'ok') out.push(...h.lines);
    else if (h.choice === 'mine') out.push(...h.mine);
    else if (h.choice === 'theirs') out.push(...h.theirs);
    else out.push(...h.mine, ...h.theirs);
  }
  return out.join('\n');
}
